import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import { editorFileUpload } from '@api/upload';
import AwaitToJs from '@/libs/awaitToJs';
import { api } from '@api/env';
var MyUploadAdapter = /*#__PURE__*/function () {
  function MyUploadAdapter(loader) {
    _classCallCheck(this, MyUploadAdapter);
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  return _createClass(MyUploadAdapter, [{
    key: "upload",
    value: function upload() {
      // return this.loader.file
      //   .then(file => new Promise((resolve, reject) => {
      //     this.uploadFile(file, resolve);
      //   }));
      return this.loader.file.then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
          var formData, _yield$AwaitToJs, _yield$AwaitToJs2, err, data;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // 上传文件
                formData = new FormData();
                formData.append('file', file);
                _context.n = 1;
                return AwaitToJs(editorFileUpload(formData));
              case 1:
                _yield$AwaitToJs = _context.v;
                _yield$AwaitToJs2 = _slicedToArray(_yield$AwaitToJs, 2);
                err = _yield$AwaitToJs2[0];
                data = _yield$AwaitToJs2[1].data;
                if (!err) {
                  _context.n = 2;
                  break;
                }
                return _context.a(2, Promise.reject(err));
              case 2:
                return _context.a(2, Promise.resolve({
                  default: "".concat(api).concat(data)
                }));
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    // Aborts the upload process.
  }, {
    key: "abort",
    value: function abort() {
      // Reject the promise returned from the upload() method.
    }
  }]);
}();
export { MyUploadAdapter };